import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import useLayoutMode from '../../../../shared/hooks/useLayoutMode';
import useTranslation from '../../../../shared/hooks/useTranslation';
import { useUiStore } from '../../../store/useUiStore';
import { useWorkspaceStore } from '../../../store/useWorkspaceStore';
import { getWorkspacePath, isWorkspaceHomePath } from '../../../../shared/utils/workspacePath';
import { runOnboardingTour } from './runOnboardingTour';
import { useOnboardingStore } from './useOnboardingStore';

export const OnboardingTour = () => {
  const { t } = useTranslation();
  const layoutMode = useLayoutMode();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const tourRequestId = useOnboardingStore((state) => state.tourRequestId);
  const isWelcomeModalOpen = useOnboardingStore((state) => state.isWelcomeModalOpen);
  const setSidebarCollapsed = useUiStore((state) => state.setSidebarCollapsed);
  const lastHandledRequestRef = useRef(0);
  const layoutModeRef = useRef(layoutMode);
  const pathnameRef = useRef(pathname);
  const translateRef = useRef(t);

  layoutModeRef.current = layoutMode;
  pathnameRef.current = pathname;
  translateRef.current = t;

  useEffect(() => {
    if (!tourRequestId || tourRequestId === lastHandledRequestRef.current) {
      return;
    }

    if (isWelcomeModalOpen) {
      return;
    }

    lastHandledRequestRef.current = tourRequestId;

    const startTour = async () => {
      try {
        const currentPath = pathnameRef.current;
        if (!isWorkspaceHomePath(currentPath)) {
          const folderId = useWorkspaceStore.getState().currentFolderId;
          navigate(folderId ? getWorkspacePath(folderId) : '/');
          await new Promise((resolve) => window.setTimeout(resolve, 350));
        }

        if (layoutModeRef.current === 'desktop') {
          setSidebarCollapsed(false);
          await new Promise((resolve) => window.setTimeout(resolve, 300));
        }

        await runOnboardingTour({
          t: translateRef.current,
          layoutMode: layoutModeRef.current,
        });
      } catch (error) {
        console.error('Onboarding tour failed:', error);
      }
    };

    void startTour();
  }, [tourRequestId, isWelcomeModalOpen, navigate, setSidebarCollapsed]);

  return null;
};
